<script setup lang="ts">
import { computed } from 'vue'

import { setCssValueUnity } from '../helpers/ui'

const props = defineProps<{
  direction?: string
  justify?: string
  align?: string
  flex?: string
  wrap?: string
  shrink?: string
  grow?: string
  basis?: string
  gap?: number
  isChild?: boolean
}>()

const directionStyles = computed(() => props.direction || 'row')
const gapStyles = computed(() => setCssValueUnity(props.gap))
</script>

<template>
  <div :class="isChild ? 'flex-child' : 'flex'">
    <slot></slot>
  </div>
</template>

<style scoped>
.flex {
  display: flex;
  flex-direction: v-bind(directionStyles);
  justify-content: v-bind(justify);
  align-items: v-bind(align);
  flex-wrap: v-bind(wrap);
  flex-shrink: v-bind(shrink);
  flex-grow: v-bind(grow);
  flex-basis: v-bind(basis);
  flex: v-bind(flex);
  gap: v-bind(gapStyles);
}

.flex-child {
  flex-shrink: v-bind(shrink);
  flex-grow: v-bind(grow);
  flex-basis: v-bind(basis);
  flex: v-bind(flex);
}
</style>
